import labels from '../../../constants/labels';
import fields from '../../../constants/fields';
import { INTERNAL_SERVER_ERR_MSG } from '../../../constants/constants';

export const manageFxAccountTableProp = {
  tableNm: 'FXG_FileX_Account_Directory',
  tableHeading: `${labels.FX_ACCOUNT} Directory`,
  resultsLabel: 'Results',
  clientEndOperation: true,
  errMsg: INTERNAL_SERVER_ERR_MSG,
  checkable: true,
  singleRowSelect: true,
  inlineItemAction: true,
  maxRowSelection: 1,
  maxRowSelectionErrMsg: 'Maximum limit of 1 record reached',
  emptyDataMsg: 'No data found',
  headers: [
    {
      sNo: 1,
      id: fields.fxAccountName,
      label: labels.FX_ACCOUNT_NAME,
      display: true,
      filter: '',
    },
    {
      sNo: 2,
      id: fields.digitalAssetGroup,
      label: labels.DIGITAL_ASSETS_GROUP,
      display: true,
      filter: '',
    },
    {
      sNo: 3,
      id: fields.amexContactEmail,
      label: labels.AMEX_CONTACT,
      display: true,
      filter: '',
    },
    {
      sNo: 4,
      id: fields.protocols,
      label: labels.PROTOCOL,
      display: true,
      filter: '',
    },
    {
      sNo: 5,
      id: fields.lastPasswordChangedTime,
      label: labels.LAST_PWD_CHANGED_TIME,
      display: true,
      filter: '',
      type: 'date',
      includeTime: true,
    },
    {
      sNo: 6,
      id: 'environment',
      label: labels.ENVIRONMENT,
      display: true,
      filter: '',
    },
    {
      sNo: 7,
      id: 'status',
      label: labels.STATUS,
      display: true,
      filter: '',
    },
  ],
  currentPage: 1,
  showLoader: true,
  showError: false,
  totalRows: 0,
  sortable: true,
  sortBy: 'fxAccountName',
  sortDirection: 'asc',
  rowKeyCol: 'rowId',
  itemsPerPage: 5,
  showFilter: false,
  rows: [],
  selectedRows: {},
  selectedRowsData: {},
  selection: { preview: false },
  actionList: [
    {
      sNo: 1,
      id: 'update_password',
      label: 'Update Password',
    },
  ],
};
